$(document).ready(function() {

    var vehicleData = null;
    if (localStorage.getItem('tyreVehicleData')) {
        vehicleData = JSON.parse(localStorage.getItem('tyreVehicleData'));
        if (vehicleData.manufacturer && vehicleData.model && vehicleData.engine && vehicleData.width && vehicleData.size) {
            $(".last-search").css("display", "block");
            $('input[name ="vehicleId"]').val(vehicleData.id);
            $('input[name ="vehicleModel"]').val(vehicleData.model);
            $('input[name ="vehicleSpecification"]').val(vehicleData.specification);
            $('input[name ="vehicleManufacturer"]').val(vehicleData.manufacturer);
            $('input[name ="vehicleEngineType"]').val(vehicleData.engine);
            $('input[name ="width"]').val(vehicleData.width);
            if ($('input[name ="sizeTyresOnCW"]').val() !== "noChanges") {
                $('input[name ="size"]').val(vehicleData.size);
            }
            $('input[name ="profile"]').val(vehicleData.tyreProfile);
            $(".last-search.h5").text(vehicleData.manufacturer + " " + vehicleData.model + " " + vehicleData.engine);
            $('input[name ="vehicle_ids"]').val(vehicleData.id);
        } else {
            $(".last-search").css("display", "none");
        }
    } else {
        $(".last-search").css("display", "none");
    }

    var $spinner = $("#loader");
    $("#carselector-default form").addClass("preselect");
    $spinner.show();

    $("body").on("carselector-default-manufacturer-done-loading", function() {
        var manufacturer = $("#carselector-default-manufacturer").val();
        $("#carselector-default-manufacturer").val(manufacturer).trigger("change");

        $spinner.fadeOut();
        $("body").off("carselector-default-manufacturer-done-loading");
    });

    $("body").on("carselector-default-model-done-loading", function() {
        var model = $("#carselector-default-model").val();
        $("#carselector-default-model").val(model).trigger("change");
        $("body").off("carselector-default-model-done-loading");
    });

    $("body").on("carselector-default-year-of-manufacture-type-done-loading", function() {
        var series = $("#carselector-default-year-of-manufacture-type").val();
        $("#carselector-default-year-of-manufacture-type").val(series).trigger("change");
        $("body").off("carselector-default-year-of-manufacture-type-done-loading");
    });

    $("body").on("carselector-default-specific-done-loading", function() {
        var series = $("#carselector-default-specific").val();
        $("#carselector-default-specific").val(series).trigger("change");
        $("body").off("carselector-default-specific-done-loading");
        $spinner.fadeOut();
    });

    // initialise gettext
    try {
        ltd('wheelshop');
    } catch (e) {

    }

    if ($("#carselector-default").length && $("#selected_car_info").css("display") !== "none") {
        var manufacturer = vehicleData !== null ? vehicleData.manufacturer : null;
        var model = vehicleData !== null ? vehicleData.model : null;
        var engine = vehicleData !== null ? vehicleData.engine : null;
        var id = vehicleData !== null ? vehicleData.specification : null;
        selectDefaultCar(manufacturer, model, engine, id);
    } else if ($("#carselector-default").length) {
        selectDefaultCar(null, null, null, null);
    }

    $('[data-toggle="tooltipTyreByVehicle"]').addClass('tooltip-for-filters').tooltip({
        template: '<div class="tooltip-serp-filters tooltip" role="tooltip"><div class="tooltip-inner"></div></div>',
        html: true,
        placement: 'right',
        container: 'body'
    });

});

function makeAjaxRequest(cmsPageId, vehicleManufacturer) {
    $.ajax({
        url: contextPath + "/ws/jfnetwork/vehicle/manufacturers",
        method: "POST",
        data: {
            cmsPageId: cmsPageId
        },
        headers: {
            "X-CSRF-TOKEN": $("input[name='_csrf']").val()
        }
    }).done(function(data) {
        var dropdown = $("#carselector-default-manufacturer");
        $(dropdown).find('option:not([value=""])').remove();
        $.each(data.list, function(index, manufacturer) {
            if (manufacturer.key === vehicleManufacturer) {
                $(dropdown).append(
                    "<option selected data-image='https://image.delti.com/simg/Logos/" + manufacturer.value.replace(" ", "") + ".png' value='" + manufacturer.key + "'>" + manufacturer.value + "</option>");
            } else {
                $(dropdown).append(
                    "<option data-image='https://image.delti.com/simg/Logos/" + manufacturer.value.replace(" ", "") + ".png' value='" + manufacturer.key + "'>" + manufacturer.value + "</option>");
            }
        });
        $(dropdown).prop('disabled', false).trigger("focus");
        $(dropdown).parent().show();
        $("body").trigger($.Event("carselector-default-manufacturer-done-loading"));
    }).fail(function(jqXHR) {
        $("#carselector-error-div").show();
    });
}

function selectDefaultCar(vehicleManufacturer, vehicleModel, vehicleEngineType, vehicleSpecification) {

    var cmsPageId = "";
    if (typeof cmsPageUid !== "undefined") {
        cmsPageId = cmsPageUid;
    }

    var preselect = $("#carselector-default form").hasClass("preselect");
    // CarSelector Default: load first dropdown (manufacturer)
    $("#carselector-default-manufacturer").prop('disabled', true)[0].options.length = 1;
    resetSelectors();
    $("#carselector-default-error").fadeOut(300, function() {
        this.remove()
    });

    var tab2Label = $('label[for="tab2"]');
    var tab2Button = $('label[for="switch-wrapper__label"]');
    var switchTab = $('label[for="swich-filter-PKW"]');
    var liElement = document.querySelector('li[data-link="byCarModel"]');
    var change = $("#car_change");
    var brandInput = $(".home-input-car-engine");

    // check if search by car model tab is already open
    // trigger ajax after window has been loaded to avoid bugs which appears if the second tab is not already loaded before checking
    if (brandInput.is(":visible")) {
        makeAjaxRequest(cmsPageId, vehicleManufacturer);
    }
    // trigger ajax when the tab2 is active
    if (tab2Label.length) {
        makeAjaxRequest(cmsPageId, vehicleManufacturer);
    // trigger for the Tirendo's switch button
    } else if (switchTab.length) {
        switchTab.one('click', function() {
            makeAjaxRequest(cmsPageId, vehicleManufacturer);
        });
        // trigger for the giga shop
    } else if ($('.btn-giga').length) {
        // trigger only if contains search by car
        if (liElement && liElement.offsetParent !== null) {
            liElement.addEventListener('click', function() {
                makeAjaxRequest(cmsPageId, vehicleManufacturer);
            }, {
                once: true
            });
        } else if (change.length) {
            change.one('click', function() {
                makeAjaxRequest(cmsPageId, vehicleManufacturer);
            });
        } else {
            makeAjaxRequest(cmsPageId, vehicleManufacturer);
        }
    }
    // every other case for search pages
    else {
        makeAjaxRequest(cmsPageId, vehicleManufacturer);
    }

    // CarSelector Default: load second dropdown (class(aka model))
    $('#carselector-default-manufacturer').on('change', function() {
        resetError();
        if (this.value !== '') {
            $('input[name=vehicleManufacturer]').val(this.value);
        }
        resetSelectors();
        $("#carselector-default-model").trigger("change");
        $("#carselector-default-year-of-manufacture-type").trigger("change");
        $("#carselector-default-specific").trigger("change");

        if (this.value === "") {
            return;
        }

        $.ajax({
            url: contextPath + "/ws/jfnetwork/vehicle/classes",
            method: "POST",
            data: {
                manufacturer: this.value,
                cmsPageId: cmsPageId
            },
            headers: {
                "X-CSRF-TOKEN": $("input[name='_csrf']").val()
            }
        }).done(function(data) {
            fillModelCar(vehicleModel, data);
            $("#carselector-default-model").trigger("change");
        }).fail(function(jqXHR) {
            $("#carselector-error-div").show();
        });
    });

    // CarSelector Default: load third dropdown (type)
    $('#carselector-default-model').on('change', function() {
        resetError();
        if (this.value !== '') {
            $('input[name=vehicleModel]').val(this.value.split("::")[1]);
        }
        $("#carselector-default-year-of-manufacture-type").prop('disabled', true)[0].options.length = 1;
        $("#carselector-default-specific").prop('disabled', true)[0].options.length = 1;
        if ($("#carselector-tyre-size").length) {
            $("#carselector-tyre-size").prop('disabled', true)[0].options.length = 1;
        }
        if ($("#carselector-default-submit-tyres")) {
            $("#carselector-default-submit-tyres").prop('disabled', true);
        }
        if ($("#carselector-default-submit-cw")) {
            $("#carselector-default-submit-cw").prop('disabled', true);
        }
        $("#carselector-default-submit").prop('disabled', true);
        $("#carselector-default-error").fadeOut(300, function() {
            this.remove()
        });

        $("#carselector-default-year-of-manufacture-type").trigger("change");
        $("#carselector-default-specific").trigger("change");

        if (this.value === "") {
            return;
        }

        $.ajax({
            url: contextPath + "/ws/jfnetwork/vehicle/years-types",
            method: "POST",
            data: {
                carClass: this.value,
                cmsPageId: cmsPageId
            },
            headers: {
                "X-CSRF-TOKEN": $("input[name='_csrf']").val()
            }
        }).done(function(data) {
            fillYearOfManufactureTypeCar(vehicleSpecification, data);
            $("#carselector-default-year-of-manufacture-type").trigger("change");
            // $("body").trigger($.Event("carselector-default-type-done-loading"));
            $("body").trigger($.Event("carselector-default-year-of-manufacture-type-done-loading"));
        }).fail(function(jqXHR) {
            $("#carselector-error-div").show();
        });
    });

    // CarSelector Default: load forth dropdown (type-details)
    $('#carselector-default-year-of-manufacture-type').on('change', function() {
        resetError();
        if (this.value !== '') {
            $('input[name=vehicleSpecification]').val(this.value.split("::")[3] + " " + typeTranslation + " " + this.value.split("::")[4]);
        }
        $("#carselector-default-specific").prop('disabled', true)[0].options.length = 1;
        if ($("#carselector-tyre-size").length) {
            $("#carselector-tyre-size").prop('disabled', true)[0].options.length = 1;
        }
        if ($("#carselector-default-submit-tyres")) {
            $("#carselector-default-submit-tyres").prop('disabled', true);
        }
        if ($("#carselector-default-submit-cw")) {
            $("#carselector-default-submit-cw").prop('disabled', true);
        }
        $("#carselector-default-submit").prop('disabled', true);
        $("#carselector-default-error").fadeOut(300, function() {
            this.remove()
        });

        $("#carselector-default-specific").trigger("change");

        if (this.value === "") {
            return;
        }
        $.ajax({
            url: contextPath + "/ws/jfnetwork/vehicle/series-versions",
            method: "POST",
            data: {
                carClass: this.value,
                cmsPageId: cmsPageId
            },
            headers: {
                "X-CSRF-TOKEN": $("input[name='_csrf']").val()
            }
        }).done(function(data) {
            fillSeriesVersionCar(vehicleEngineType, data);
            $("#carselector-default-specific").trigger("change");
            $("body").trigger($.Event("carselector-default-specific-done-loading"));
        }).fail(function(jqXHR) {
            $("#carselector-error-div").show();
        });
    });

    // CarSelector Default: show submit on fifth dropdown selection
    $("#carselector-default-specific").on('change', function() {
        resetError();
        preselect = false;
        if (this.value !== '') {
            $('input[name=vehicleId]').val(this.value.split("::")[0]);
            $('input[name=vehicleEngineType]').val($("#carselector-default-specific option:selected").text());
            $('input[name=fuelCode]').val(this.value.split("::")[1]);
            $("#carselector-default-submit").prop('disabled', false).trigger("focus");
        } else {
            $("#carselector-default-submit").prop('disabled', true);
        }
    });
}

function resetSelectors() {
    $("#carselector-default-model").prop('disabled', true)[0].options.length = 1;
    $("#carselector-default-year-of-manufacture-type").prop('disabled', true)[0].options.length = 1;
    $("#carselector-default-specific").prop('disabled', true)[0].options.length = 1;
    if ($("#carselector-tyre-size").length) {
        $("#carselector-tyre-size").prop('disabled', true)[0].options.length = 1;
    }
    if ($("#carselector-default-submit-tyres")) {
        $("#carselector-default-submit-tyres").prop('disabled', true);
    }
    if ($("#carselector-default-submit-cw")) {
        $("#carselector-default-submit-cw").prop('disabled', true);
    }
    $("#carselector-default-submit").prop('disabled', true);
}

function fillModelCar(vehicleModel, data) {
    var dropdown = $("#carselector-default-model");
    $(dropdown).find('option:not([value=""])').remove();
    $.each(data.list, function(index, model) {
        if (model.value === vehicleModel) {
            $(dropdown).append(
                "<option selected value='" + model.key + "'>" + model.value + "</option>");
        } else {
            $(dropdown).append(
                "<option value='" + model.key + "'>" + model.value + "</option>");
        }
    });

    if (data.list.length === 1) {
        // select first element
        $(dropdown).val(data.list[0].key);
        $(dropdown).trigger("change");
    }

    $(dropdown).prop('disabled', false).trigger("focus");
    $(dropdown).parent().show();
}

function fillYearOfManufactureTypeCar(vehicleEngineType, data) {
    var versionDropdown = $("#carselector-default-year-of-manufacture-type");
    $(versionDropdown).find('option:not([value=""])').remove();
    $.each(data.yearOfManufactureType, function(index, yearTypes) {
        var yearOfManufactureTypeText = yearTypes.name.split("::")[0] + " " + typeTranslation + " " + yearTypes.name.split("::")[1];
        if (yearOfManufactureTypeText === vehicleEngineType) {
            $(versionDropdown).append("<option selected value='" + yearTypes.key + "'>" + yearOfManufactureTypeText + "</option>");
        } else {
            $(versionDropdown).append("<option value='" + yearTypes.key + "'>" + yearOfManufactureTypeText + "</option>");
        }
    });

    if (data.yearOfManufactureType.length === 1) {
        // select first element
        $(versionDropdown).val(data.yearOfManufactureType[0].key);
        $(versionDropdown).trigger("change");
    } else if (data.yearOfManufactureType.length === 0) {
        $("#carselector-error-div").show();
    }
    $(versionDropdown).prop('disabled', false).trigger("focus");
    $(versionDropdown).parent().show();
}

function fillSeriesVersionCar(vehicleSpecification, data) {
    var dropdown = $("#carselector-default-specific");
    $(dropdown).find('option:not([value=""])').remove();
    var briefTypeDetails = data.seriesVersion.map((typedetails) => {
        return typedetails.name.split("::")[0] + " kW/" + typedetails.name.split("::")[1] + " PS" + typedetails.name.split("::")[2];
    });
    var occurrences = {};
    briefTypeDetails.map((typeDetail) => {
        occurrences[typeDetail] = occurrences[typeDetail] ? occurrences[typeDetail] + 1 : 1;
    });
    $.each(data.seriesVersion, function(index, typedetails) {
        var briefTypeDetails = typedetails.name.split("::")[0] + " kW/" + typedetails.name.split("::")[1] + " PS" + typedetails.name.split("::")[2];
        var seriesVersionText = briefTypeDetails + " " + (typedetails.name.split("::")[3] && occurrences[briefTypeDetails] > 1 ? standardSizeTranslation + " " + typedetails.name.split("::")[3] + " " + inchTranslation : "");
        if (typedetails.key === vehicleSpecification || seriesVersionText === vehicleSpecification) {
            $(dropdown).append("<option selected value='" + typedetails.key + "::" + typedetails.name.split("::")[4] + "'>" + seriesVersionText + "</option>");
        } else {
            $(dropdown).append("<option value='" + typedetails.key + "::" + typedetails.name.split("::")[4] + "'>" + seriesVersionText + "</option>");
        }
    });

    if (data.seriesVersion.length === 1) {
        // select first element
        $(dropdown).val(data.seriesVersion[0].key + "::" + data.seriesVersion[0].name.split("::")[4]);
        $('#carselector-default-specific').trigger("change");
        $("#carselector-default-submit").prop('disabled', false).trigger("focus");
    } else if (data.seriesVersion.length === 0) {
        $("#carselector-error-div").show();
    }

    $(dropdown).prop('disabled', false).trigger("focus");
    $(dropdown).parent().show();
}

function resetError() {
    //reset error message to default and hide previous error
    $("#carselector-error-span").text(defaultErrorMessage);
    $("#carselector-error-div").hide();
}

$("#driveRight-carselector-tyre-size").on('change', function() {
    preselect = false;
    if (this.value != '') {
        populateVehicleInfoSearchForm($("#driveRight-carselector-tyre-size").val());
        $("#tyreDimensionsSubmitButton").prop('disabled', false);
        $("#submitButtonDiv").show();
    } else {
        $("#tyreDimensionsSubmitButton").prop('disabled', true);
    }
});

var populateVehicleInfoSearchForm = function(data) {
    // split by pipe creates individual values
    var values = data.split("|");
    var formValues = {
        width: values[0],
        profile: values[1],
        constructionType: values[2],
        size: values[3],
        loadIndex: values[4],
        speedRating: values[5]
    };
    for (var key in formValues) {
        $("#searchByVehicleInfoForm input[name='" + key + "']").val(formValues[key]);
    }
};

function chooseMyCar(vehicleManufacturer, vehicleModel, vehicleEngineType, vehicleSpecification) {

    var cmsPageId = "";
    resetError();
    resetSelectors();

    $('input[name=vehicleManufacturer]').val(vehicleManufacturer);
    $('input[name=vehicleModel]').val(vehicleModel);
    $('input[name=vehicleSpecification]').val(vehicleSpecification);

    $("#carselector-default-manufacturer").val(vehicleManufacturer);
    $("#carselector-default-manufacturer").trigger("change-car");

    $.ajax({
        url: contextPath + "/ws/jfnetwork/vehicle/classes",
        method: "POST",
        data: {
            manufacturer: vehicleManufacturer,
            cmsPageId: cmsPageId
        },
        headers: {
            "X-CSRF-TOKEN": $("input[name='_csrf']").val()
        }
    }).done(function(data) {
        fillModelCar(vehicleModel, data);
        $("#carselector-default-model").trigger("change-car");
        if (data.list.length > 1) {
            $.ajax({
                url: contextPath + "/ws/jfnetwork/vehicle/years-types",
                method: "POST",
                data: {
                    carClass: $("#carselector-default-model").val(),
                    cmsPageId: cmsPageId
                },
                headers: {
                    "X-CSRF-TOKEN": $("input[name='_csrf']").val()
                }
            }).done(function(data) {
                fillYearOfManufactureTypeCar(vehicleSpecification, data);
                $("#carselector-default-year-of-manufacture-type").trigger("change-car");
                $.ajax({
                    url: contextPath + "/ws/jfnetwork/vehicle/series-versions",
                    method: "POST",
                    data: {
                        carClass: $("#carselector-default-year-of-manufacture-type").val(),
                        cmsPageId: cmsPageId
                    },
                    headers: {
                        "X-CSRF-TOKEN": $("input[name='_csrf']").val()
                    }
                }).done(function(data) {
                    fillSeriesVersionCar(vehicleEngineType, data);

                    $("#carselector-default-specific").trigger("change-car");
                    $("#carselector-default-specific").trigger("change");

                    $("body").trigger($.Event("carselector-default-specific-done-loading"));
                }).fail(function(jqXHR) {
                    $("#carselector-error-div").show();
                });
            }).fail(function(jqXHR) {
                $("#carselector-error-div").show();
            });
        }
    }).fail(function(jqXHR) {
        $("#carselector-error-div").show();
    });
}